import { Box, Divider, Link } from "@mui/material";

function Footer() {
  return (
    <>
      <Divider />
      <Box
        display="flex"
        width="100%"
        justifyContent="space-between"
        p={2}
        sx={{ bgcolor: "#121212", color: "#fff" }}
      >
        <div style={{ flex: 1, textAlign: "left" }} />
        <Link
          sx={{ flex: 1, textAlign: "center", color: "#fff" }}
          href="mailto:info@gratcircle.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          info@gratcircle.com
        </Link>
        <div style={{ flex: 1, textAlign: "right" }}>
          Ⓒ 2022 Gratitude Circle, LLC
        </div>
      </Box>
    </>
  );
}

export default Footer;
